module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress rounded-0",
    on: {
      "click": function($event) {
        return _vm.seek()
      }
    }
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.position + '%'
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": _vm.position
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f0b111b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/modules/ProgressBar.vue
// module id = 795
// module chunks = 3